// 全局默认配置项
// 首页地址[默认]
export const HOME_URL: string = '/chat';

// 默认主题颜色
export const DEFAULT_THEME_COLOR: string = '#2992FF';

// 折叠阈值
export const COLLAPSE_THRESHOLD: number = 600;

// 左侧菜单宽度
export const SIDE_BAR_WIDTH: number = 280;

// 路由白名单地址[本地存在的路由 staticRouter.ts 中]
// 包含所有无需登录即可访问的公开路径
export const ROUTER_WHITE_LIST: string[] = [
  '/chat',
  '/chat/conversation',
  '/chat/image',
  '/chat/video',
  '/chat/agent',
  '/chat/api',
  '/chat/yxcode',
  '/chat/claw',
  '/model-library',
  '/products',
  '/pay-result',
  '/activity/:id',
  '/announcement/:id',
  '/403',
  '/404',
  '/apikey-usage',
  '/ranking',
  'coding-plan',
  '/docs',
  '/docs/:slug',
];
